'use strict';

var getActiveElement = require('../../../../_virtual/getActiveElement.js_commonjs-exports.js');

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getActiveElement;

function getActiveElement() {
  return typeof document !== 'undefined' && document.activeElement;
}
}(getActiveElement.__exports));
